<mat-card>
  <form name="organisationForm" [formGroup]="form">

    <h3>Organiser details</h3>
    <p>Please fill in the details below so we can contact you regarding your event. This information will not be published on your event listing.</p>
    <div class="row">
      <div class="col-md-6">

        <mat-form-field appearance="outline">
          <input matInput required formControlName="firstname" name="organiser_firstname"
            aria-label="Organiser first name" (focusout)="trimValue($event,'firstname')">
          <mat-label>First Name</mat-label>
          <mat-hint>Please enter your first name.</mat-hint>
          <mat-error *ngIf="form.get('firstname').invalid">{{getErrorMessage('firstname')}}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <input matInput required formControlName="surname" name="organsier_surname" aria-label="Organiser surname"
            (focusout)="trimValue($event,'surname')">
          <mat-label>Surname</mat-label>
          <mat-hint>Please enter your surname.</mat-hint>
          <mat-error *ngIf="form.get('surname').invalid">{{getErrorMessage('surname')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <input matInput required formControlName="email" name="organiser_email" aria-label="Email Address"
            type="email" (focusout)="trimValue($event,'email')">
          <mat-label>Email Address</mat-label>
          <mat-icon matSuffix>email</mat-icon>
          <mat-hint>We will use this to contact you regarding this event.</mat-hint>
          <mat-error *ngIf="form.get('email').invalid">{{getErrorMessage('email')}}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <input matInput formControlName="phone" name="organiser_phone" aria-label="Organiser Phone"
            type="tel" (focusout)="trimValue($event,'phone', 'phone')" (focus)="prefillphone($event,'phone')">
          <mat-label>Contact Phone</mat-label>
          <mat-icon matSuffix>phone</mat-icon>
          <mat-hint>Phone number to contact you regarding this event.</mat-hint>
          <mat-error *ngIf="form.get('phone').invalid">{{getErrorMessage('phone')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>